// @ts-check

import { Trigger } from './Trigger'

/**
 * @typedef {Object} ScrollPercentageOptions
 * @property {number} percentage scroll percentage for trigger to fire
 */

/**
 * Implements a Time based trigger that fires whenever x seconds has been
 * passed.
 */
class ScrollPercentageTrigger extends Trigger {
  timeoutHandler

  /**
   *
   * @param {ScrollPercentageOptions} options
   */
  constructor({ percentage }) {
    super()
    this.timeoutHandler = setInterval(() => {
      if (getScrollPercent() >= percentage) this._dispatch()
    }, 250)
  }

  destroy() {
    clearTimeout(this.timeoutHandler)
    super.destroy()
  }
}

/**
 * Get current browser viewpane height
 */
function getWindowHeight() {
  return (
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight ||
    0
  )
}

/**
 * Get current absolute window scroll position
 */
function getWindowYscroll() {
  return (
    window.pageYOffset ||
    document.body.scrollTop ||
    document.documentElement.scrollTop ||
    0
  )
}

/**
 * Get current absolute document height
 */
function getDocHeight() {
  return Math.max(
    document.body.scrollHeight || 0,
    document.documentElement.scrollHeight || 0,
    document.body.offsetHeight || 0,
    document.documentElement.offsetHeight || 0,
    document.body.clientHeight || 0,
    document.documentElement.clientHeight || 0
  )
}

/**
 * Get current vertical scroll percentage
 */
function getScrollPercent() {
  return ((getWindowYscroll() + getWindowHeight()) / getDocHeight()) * 100
}

export { ScrollPercentageTrigger }
